import * as React from 'react';

import { useIntl } from 'react-intl';

import {
  RutwClockColon,
  RutwClockWrapper,
  SideHeaderText,
  SideSubHeaderText,
  Timer,
  TimerText,
} from './rutw-countdown.styled';
import { IRutwCountdownProps } from './types';

const RutwCountdown = ({ days, hours, minutes }: IRutwCountdownProps) => {
  const { formatMessage } = useIntl();
  return (
    <RutwClockWrapper data-testid="rutw-countdown">
      <SideHeaderText>{formatMessage({ id: 'only' })}</SideHeaderText>
      <div>
        <Timer data-testid="days">{days}</Timer>
        <TimerText>{formatMessage({ id: 'days' })}</TimerText>
      </div>
      <RutwClockColon>:</RutwClockColon>
      <div>
        <Timer data-testid="hours">{hours}</Timer>
        <TimerText>{formatMessage({ id: 'hours' })}</TimerText>
      </div>
      <RutwClockColon>:</RutwClockColon>
      <div>
        <Timer data-testid="minutes">{minutes}</Timer>
        <TimerText>{formatMessage({ id: 'min' })}</TimerText>
      </div>
      <div>
        <SideHeaderText>{formatMessage({ id: 'left' })}</SideHeaderText>
        <SideSubHeaderText>{formatMessage({ id: 'toEarnRolls' })}</SideSubHeaderText>
      </div>
    </RutwClockWrapper>
  );
};

export default RutwCountdown;
